import type { ProjectId } from 'common/types'

import type { Calculation, FormDataML } from '../../types'
import { constructClientDispenser } from '../clientDispenserFactory'
import { axiosInstance } from '../common'
import { HttpClient } from './__generated__/http-client'
import { MlCalcClient } from './__generated__/MlCalc'
import { convertToMlCalcHorizonModel } from './machineLearningConverters'

const Clients = {
  MlCalcClient,
} as const

const getClient = constructClientDispenser(Clients, HttpClient, axiosInstance)

export function calculateHorizonApi(
  calculation: Calculation,
  formData: FormDataML,
  projectId: ProjectId,
): Promise<string> {
  const client = getClient('MlCalcClient')
  const { data, query } = convertToMlCalcHorizonModel(calculation, formData, projectId)
  return client.mlCalcExecuteHorizonCalculation(query, data)
}
